import { createHttpSelectors } from '../../redux/http-descriptor';

export const getProducts = state => state.products;

export default {
  getProducts,
  ...createHttpSelectors('carDataImport', 'get', getProducts),
  ...createHttpSelectors('carDataImportItem', 'put', getProducts),
};
